import { getViemClients, } from "@bracket/contractor-next";
import { getContractWithABI, } from "@bracket/chainography";
import type { ValidChainId, } from "@bracket/types";
import type { Config } from "@wagmi/core";



export declare type getTotalValueProps = {
	chainId?: ValidChainId;
	config?: Config;
};




export const getTotalValue = async ({
	chainId = 1,
	config,
}: getTotalValueProps = {}): Promise<bigint> => {

	try {
		if(chainId !== 1) throw new Error("getTotalValue supports only chain 1");
		const [vclient, _] = await getViemClients({ chainId, config, });
		const [address, abi] = getContractWithABI("BrktETH");
		const result = await vclient.readContract({
			address,
			abi,
			functionName: "getTotalValue",
			args: [
			]
		});

		if(typeof result === "bigint") {
			return result;
		}

		throw new Error("contract did not return the expected value as a bigint");
	} catch (err) {

		throw new Error(`@bracket/chainography/brktETH:getTotalValue failed - ${err.message}`);
	}
};
